import React from "react";

import Button from "@common/components/Button/Button";
import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { Spinner } from "@common/components/Spinner/Spinner";
import useMttrScoring from "@main/pages/Release/consumers/useMttrScoring";
import { MetricScoreOutletContext } from "@main/pages/Release/views/MetricDetails/ReleaseMetricDetailsLayout";
import { MetricRow } from "@main/pages/Release/views/MetricDetails/shared/MetricRow";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";
import { useOutletContext } from "react-router-dom";

import * as Styled from "./MttrScoreView.styles";

export default function MttrScoreView() {
  const { refetchReleaseStatus } = useOutletContext<MetricScoreOutletContext>();
  const { thresholdRows, scoringConfigLoading, handleSave, isSaving } = useMttrScoring(refetchReleaseStatus);

  if (scoringConfigLoading) {
    return <Spinner />;
  }

  const hasThresholdError = thresholdRows.map((t) => Boolean(t.error)).includes(true);

  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          Score
        </Heading>
        <Heading
          heading4
          fontWeight={"bold"}
          marginBottom={16}
        >
          Mapping
        </Heading>

        <Paragraph>
          {"The 'Mean time to resolve' (MTTR) is mapped to a score based on the thresholds below. You can fine-tune them to match your team's standards.\n" +
            "Lower MTTR indicates faster defect resolution. An MTTR of 1 day means defects are typically resolved within 24 hours of being reported.\n" +
            "Within each range, the score interpolates linearly between adjacent thresholds. A value exactly halfway between two thresholds gives a score halfway between their assigned scores."}
        </Paragraph>

        <Styled.ThresholdList>
          {thresholdRows.map((row) => (
            <MetricRow
              key={row.score}
              description={row.description}
              value={row.value}
              error={row.error}
              onChange={row.onChange}
              score={row.score}
              unit={"days"}
              showScore
            />
          ))}
        </Styled.ThresholdList>

        <Button
          type="submit"
          size="small"
          disabled={hasThresholdError || isSaving}
          onClick={handleSave}
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
